// Intl.NumberFormatOptions shared across v2 surfaces that use <NumberFlowV2>.
// Centralised so the currency display (narrow-symbol "$" instead of "A$") and
// fraction-digit rules stay consistent between the cost breakdown, place-order
// button, cart-timer badge, and ticket-row totals.

export const CURRENCY_FORMAT_OPTIONS = Object.freeze({
    style: 'currency',
    currency: 'AUD',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const INTEGER_FORMAT_OPTIONS = Object.freeze({
    maximumFractionDigits: 0,
});

// Two-digit zero-padded integer (e.g., seconds in the cart timer 0:09 / 1:42).
export const PAD2_FORMAT_OPTIONS = Object.freeze({
    minimumIntegerDigits: 2,
    maximumFractionDigits: 0,
});
